import * as React from 'react';
import { useEffect } from 'react';
import { formatNumber } from '../../shared/helpers/formatNumber';
import { useWindowWidth } from '@react-hook/window-size/throttled';

const HighchartsReact = React.lazy(() => import('../../shared/helpers/highcharts'));

interface AlphaProgressBarProps {
  value: number;
  maxValue: number;
  progressLabel: string;
  graphColor?: string;
  width?: number;
}

function TutorialProgressBar({ value, maxValue, progressLabel, graphColor, width }: AlphaProgressBarProps) {
  useWindowWidth({ fps: 5 });
  const graphValue = Math.min(value, maxValue);
  const percentCount = (graphValue / maxValue) * 100;
  const progressPercentage = formatNumber(percentCount, 'integer', { numFractionDigits: 0 });
  useEffect(() => {
    // @ts-ignore
    setTimeout(() => window.dispatchEvent(new Event('resize')));
  }, [width]);

  const configBarChart = () => ({
    title: false,
    chart: {
      renderTo: 'container',
      type: 'bar',
      height: 60,
      spacingBottom: 0,
      spacingTop: 0,
      borderRadius: 20,
    },
    credits: false,
    tooltip: false,
    legend: false,
    navigation: {
      buttonOptions: {
        enabled: false,
      },
    },
    xAxis: {
      visible: false,
    },
    yAxis: {
      visible: false,
      min: 0,
      max: maxValue,
      endOnTick: false,
    },
    series: [
      {
        data: [maxValue],
        grouping: false,
        animation: false,
        enableMouseTracking: false,
        showInLegend: false,
        color: '#acacac',
        pointWidth: 30,
        borderWidth: 0,
        borderRadius: 8,
        dataLabels: {
          className: 'highlight',
          format: progressLabel,
          enabled: true,
          align: 'right',
          style: {
            color: 'white',
            textOutline: false,
          },
        },
      },
      {
        enableMouseTracking: false,
        data: [graphValue],
        color: graphColor ?? 'rgb(83,174,207)',
        borderRadius: 8,
        borderWidth: 0,
        borderBottomRightRadius: 8,
        pointWidth: 30,
        animation: {
          duration: 250,
        },
        dataLabels: {
          enabled: true,
          inside: true,
          align: 'left',
          format: `${progressPercentage}%`,
          style: {
            color: 'white',
            textOutline: false,
          },
        },
      },
    ],
  });

  const barChartConfig = configBarChart();

  return (
    <div className="tutorial__progress-bar-container">
      <HighchartsReact options={barChartConfig} />
    </div>
  );
}

export const MemoizedTutorialProgressBar = React.memo(TutorialProgressBar);
